import { render, staticRenderFns } from "./report_doc.vue?vue&type=template&id=e2c0a8a0&scoped=true&"
import script from "./report_doc.vue?vue&type=script&lang=js&"
export * from "./report_doc.vue?vue&type=script&lang=js&"
import style0 from "./report_doc.vue?vue&type=style&index=0&id=e2c0a8a0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e2c0a8a0",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/host/imc/portal/dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('e2c0a8a0')) {
      api.createRecord('e2c0a8a0', component.options)
    } else {
      api.reload('e2c0a8a0', component.options)
    }
    module.hot.accept("./report_doc.vue?vue&type=template&id=e2c0a8a0&scoped=true&", function () {
      api.rerender('e2c0a8a0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "assets/js/components/com_report/doc/report_doc.vue"
export default component.exports